var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.wrapperClass ? _vm.wrapperClass : 'd-inline-flex']},[_c(_vm.icon,{tag:"Component",attrs:{"width":_vm.width,"color":_vm.color || _vm.accentColor}}),(_vm.text)?_c('p',{staticClass:"font-weight-light text-center mt-4"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }